module.exports = __webpack_public_path__ + "static/media/21ECLAC37.ad3b012d.jpg";